import UserAuthNetwork from '../network/UserAuthNetwork';

const ConfirmUserRequests = {
    confirmUser(context) {
        UserAuthNetwork.confirmUser(context);
    }
}

export default ConfirmUserRequests;